import altImage from '../img/app_icon.png'

export const showAltImage = (e) => {
  if (e?.target) {
    e.target.src = altImage
  } else {
    console.error('Event target is missing in AltImage')
  }
}
